import { Text } from '@cleartax/wg-library-typography';
import SanitizedHTML from 'react-sanitized-html';
import {
  TSearchHighlight,
  TSearchItem
} from '../../../../../../../pages/services/[planSeoSlug]/api/types';
import styles from './sanitize.module.css';

interface IDesktopCustomSearchResult {
  searchItem: TSearchItem;
  seachHighlights: TSearchHighlight;
}

export const DekstopCustomSearchResult: React.FC<
  IDesktopCustomSearchResult
> = ({ searchItem, seachHighlights }) => {
  const nameHighlight = seachHighlights.find(
    (highlight) => highlight.field === 'name'
  );
  return (
    <Text
      type="a"
      mergeClasses="override"
      href={`/services/${searchItem.seo_slug}/p`}
      className={`${styles.customMark} cursor-pointer p-3 w-full block font-medium text-grey-600 hover:bg-brand-200 sm:font-normal sm:text-brand-1000 sm:text-base sm:hover:bg-white sm:overflow-hidden sm:max-w-[100vw] sm:p-5`}
    >
      {nameHighlight ? (
        <SanitizedHTML
          className={
            'sm:overflow-ellipsis sm:whitespace-nowrap sm:overflow-hidden sm:max-w-full'
          }
          html={nameHighlight.snippet}
        />
      ) : (
        searchItem.name
      )}
    </Text>
  );
};
